export const DEFAULT_SORT_ORDER = {
  id: 'name',
};
